/* import __COLOCATED_TEMPLATE__ from './sq-help-link.hbs'; */
import { notEmpty, reads } from '@ember/object/computed';
import { computed, set } from '@ember/object';
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import sqHelpLink from '@dashboard/junk-drawer/utils/sq-help-link';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  dataApi: service(),
  userInfo: service(),
  init(...args) {
    this._super(...args);
    if (!this.utmParams) {
      set(this, 'utmParams', {
        utmSource: 'dashboard',
        utmMedium: 'web'
      });
    }
  },
  eventName: null,
  eventProperties: null,
  articleId: null,
  articleSection: null,
  tagName: 'a',
  attributeBindings: ['href', 'target'],
  target: '_blank',
  classNameBindings: ['showRightCaret:action-caret-right'],
  linkText: null,
  hasLinkText: notEmpty('linkText'),
  showRightCaret: reads('hasLinkText'),
  utmParams: null,
  href: computed('articleId', 'articleSection', 'utmParams.{utmContent,utmSource,utmMedium,utmCampaign}', 'userInfo.{countryCode,languageCode}', function () {
    return sqHelpLink({
      articleId: this.articleId,
      articleSection: this.articleSection,
      utmParams: this.utmParams,
      userInfo: this.userInfo
    });
  }),
  click() {
    if (this.eventName) {
      this.dataApi.track(this.eventName, this.eventProperties);
    }
  }
});